import React from 'react';
import PropTypes from 'prop-types';
import CourseContentDetails from '../../../academy/details/CourseContentDetails';
import JourneyStepProp from '../../propTypes/journeyStepProp';
import AppProductProp from '../../../profile/propTypes/appProductProp';
import CountryProp from '../../../../commonComponents/forms/Address/CountryProp';
import StripeCardProp from '../../../profile/propTypes/StripeCardProp';
import { useLoader } from '../../../../services/customHooks';
import ScormDetail from '../../../academy/details/ScormDetail';

export default function JourneyContentCourse(props) {
  const {
    step,
    appProducts,
    countries,
    cards,
    onChange,
    pspdfkitLicenseKey,
    journeyId,
    sessionContext,
    onSkipStep,
  } = props;
  const stepCourse = step.course || {};
  const containerId = 'journey-course-container';

  let url = `/academy/${stepCourse._id}/data?journeyContext=${journeyId}`;
  if (sessionContext) {
    url += `&sessionContext=${sessionContext}`;
  }
  if (stepCourse.gameId) {
    url += `&gameId=${stepCourse.gameId}`;
  }
  const {
    data,
    setData: setCourse,
    isLoading,
  } = useLoader(url, 'error_fetchStepCourse', null, [url], containerId);

  const handleCourseChange = c => {
    setCourse(c);
    onChange(c);
  };
  const course = data || {};

  return (
    <div id={containerId}>
      {!isLoading && !course.isFromExternalProvider && (
        <CourseContentDetails
          course={course}
          gameId={course.gameId}
          cards={cards}
          appProducts={appProducts}
          countries={countries}
          onCourseChange={handleCourseChange}
          inJourney
          pspdfkitLicenseKey={pspdfkitLicenseKey}
          journeyContext={journeyId}
          sessionContext={sessionContext}
          onSkipStep={onSkipStep}
        />
      )}
      {!isLoading && course.isFromExternalProvider && (
        <ScormDetail
          shouldScrollContent={false}
          showEnrollOverlay={false}
          course={course}
          title={course.name}
          url={course.provider.config.scorm.urlUser || ''}
          cards={cards}
          appProducts={appProducts}
          countries={countries}
          inJourney
          sessionContext={sessionContext}
          journeyContext={journeyId}
        />
      )}
    </div>
  );
}

JourneyContentCourse.propTypes = {
  step: PropTypes.shape(JourneyStepProp.propType).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(StripeCardProp.propType)).isRequired,
  onChange: PropTypes.func.isRequired,
  appProducts: PropTypes.arrayOf(PropTypes.shape(AppProductProp.propType))
    .isRequired,
  pspdfkitLicenseKey: PropTypes.string,
  journeyId: PropTypes.string.isRequired,
  sessionContext: PropTypes.string,
  onSkipStep: PropTypes.func.isRequired,
};

JourneyContentCourse.defaultProps = {
  pspdfkitLicenseKey: null,
  sessionContext: null,
};
